import Text from './Text/Controller';
import Title from './Title/Controller';
import Password from './Password/Controller';
import MapController from './Map';
import DividerController from './Divider';
import GridRowBreak from './GridRowBreak';
import DocumentController from './Document';
import DatePickerController from './DatePicker';
import Textarea from './Textarea';
import PopperSelect from './PopperSelect';
import SelectController from './Select/Controller';
import ColorPicker from './ColorPicker';
import Recaptcha from './Recaptcha/Controller';
import AcceptConditions from './AcceptConditions';
import StaticImageMap from './StaticImageMap';

const availableFormControllersHashMap = {
  text: Text,
  email: Text,
  title: Title,
  password: Password,
  'accept-terms-conditions': AcceptConditions,
  map: MapController,
  'map-static': StaticImageMap,
  textarea: Textarea,
  recaptcha: Recaptcha,
  'color-picker': ColorPicker,
  select: SelectController,
  document: DocumentController,
  'popper-select': PopperSelect,
  'grid-row-break': GridRowBreak,
  'simple-divider': DividerController,
  datetimepicker: DatePickerController,
};

export default availableFormControllersHashMap;
